import React, { useState } from "react";
import { FiCopy, FiShare2 } from "react-icons/fi"; // Feather icons for Copy and Share
import "./CopyUrlComponent.css"; // Add necessary styling here
import { useTheme } from "../../context/ThemeContext";

const CopyUrlComponent = ({ url }) => {
    const { themeStyles } = useTheme();
    const [isCopied, setIsCopied] = useState(false);

    // Copy URL to Clipboard
    const handleCopy = () => {
        navigator.clipboard.writeText(url);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    // Share URL (Web Share API)
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Share Quiz Link",
                    url,
                });
            } catch (error) {
                console.error("Error sharing the link:", error);
            }
        } else {
            alert("Sharing is not supported in this browser.");
        }
    };

    return (
        <div
            className={`p-6 rounded-lg shadow-md border`}
            style={{
                background: themeStyles.cardBackground,
                color: themeStyles.text,
            }}
        >
            {/* Tutor Instructions */}
            <h2 className="text-lg font-semibold mb-3 text-blue-600">
                🎓 Share this quiz link with your students:
            </h2>
            {/* URL and Icons */}
            <div className="flex items-center border rounded-md overflow-hidden">
                <input
                    type="text"
                    value={url}
                    readOnly
                    className={`w-full px-4 py-2 text-sm`}
                    style={{ backgroundColor: themeStyles.cardContentBackground, }}
                />
                <div className="flex items-center gap-2 px-3">
                    {/* Copy Button */}
                    <button
                        onClick={handleCopy}
                        className="p-2 rounded-md text-blue-500 hover:bg-blue-100 transition"
                        title="Copy URL"
                    >
                        <FiCopy size={20} />
                    </button>
                    {/* Share Button */}
                    <button
                        onClick={handleShare}
                        className="p-2 rounded-md text-green-500 hover:bg-green-100 transition"
                        title="Share URL"
                    >
                        <FiShare2 size={20} />
                    </button>
                </div>
            </div>
            {/* Copied Tooltip */}
            {isCopied && (
                <p className="mt-2 text-sm text-green-500">
                    ✅ Link copied successfully!
                </p>
            )}
        </div>
    );
};

export default CopyUrlComponent;
